module.exports = __webpack_public_path__ + "img/1_2_1.b7b9be75.jpg";